import React from 'react';
import Chart from "chart.js"
import EpflLoader from './../helper/EpflLoader.jsx';
import morgenstemning from './../cmap/morgenstemning.json'
import challengeData from './../dataStruct/challengeData.json'
import MT1_XY from './activations/MT1_activations_XY.png';
import MT2_XY from './activations/MT2_activations_XY.png';
import MT3_XY from './activations/MT3_activations_XY.png';
import MT4_XY from './activations/MT4_activations_XY.png';
import ER1_XY from './activations/ER1_activations_XY.png';
import ER2_XY from './activations/ER2_activations_XY.png';
import MT1_XZ from './activations/MT1_activations_XZ.png';
import MT2_XZ from './activations/MT2_activations_XZ.png';
import MT3_XZ from './activations/MT3_activations_XZ.png';
import MT4_XZ from './activations/MT4_activations_XZ.png';
import ER1_XZ from './activations/ER1_activations_XZ.png';
import ER2_XZ from './activations/ER2_activations_XZ.png';

class SubmitResults extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            FileHeader: [],                
            FileData:[],
            FileName:'',
            FileNameBeads:'',
            FileDataBeads: [],
            update:false,
            response:0, // 0 : no response yet, 1 response is OK, -1 error in response
            assessment: [],
            isLoading:false,
            xid: 1, yid: 2, zid: 3, fid: 0 // fid : frame id
        }
        this.fovxnm = 0;
        this.fovynm = 0;
        this.fovznm = 0;
        this.psXY = 10; // 10 nm is default pixel size
        this.psZ = 50; // sampling step for z-color coding
        this.A = 5; // brightness multiplication
        this.cFactor = [1,1,1];
        this.flipY = false;
        this.flipZ = false;
        this.zOffset = 0;
        this.offset50nm = false;
        this.frameIndex = 1; // starting frame index 1 or 0
        this.beadsX = [];
        this.beadsY = [];
        this.timeout=null;
        this.dataId = 0;
        this.refIm_XY = {"MT1.N1.LD":MT1_XY,"MT2.N1.HD":MT2_XY,"MT3.N2.LD":MT3_XY,"MT4.N2.HD":MT4_XY,"ER1.N3.LD":ER1_XY,"ER2.N3.HD":ER2_XY};
        this.refIm_XZ = {"MT1.N1.LD":MT1_XZ,"MT2.N1.HD":MT2_XZ,"MT3.N2.LD":MT3_XZ,"MT4.N2.HD":MT4_XZ,"ER1.N3.LD":ER1_XZ,"ER2.N3.HD":ER2_XZ};
        this.chart = null;
        this.onChange.bind(this);
        this.onChangeBeads.bind(this);
        this.getMean.bind(this);
        this.uploadResults.bind(this);
        this.updatePlot.bind(this);
        this.updateBeadsPlot.bind(this);
        this.getMaxProj.bind(this);
        this.doDelayedUpdate.bind(this);
        this.parseConversionFactor.bind(this);
       }

    onChange(e) {

        let files = e.target.files;
        let reader = new FileReader();
        let csv_sep = document.getElementById("csv_sep").value;

        reader.readAsText(files[0]);
        //once data is loaded
        reader.onload= (e)=> {
            let allText = e.target.result;
            var allTextLines = allText.split(/\r\n|\n/);
            var headers = allTextLines[0].split(csv_sep);

            if (headers.length === 1)
                return

            var lines = [];
        
            for (var i=1; i<Math.min(allTextLines.length,80000); i++) {
                var data = allTextLines[i].split(csv_sep);
                if (data.length === headers.length) {
                    var tarr = [];
                    for (var j=0; j<headers.length; j++) {
                        tarr.push(data[j]);
                    }
                    lines.push(tarr);
                }
            }
            // try to guess which header for each axis
            let xid = -1; let yid = -1; let zid = -1; let fid = -1
            if (isNaN(parseFloat(headers[0]))) { // if header is not a number
                headers.forEach((h,i) => {
                    h = h.toUpperCase()
                    if (h[0] === 'X' & xid == -1)
                        xid = i
                    if (h[0] === 'Y' & yid == -1)
                        yid = i
                    if (h[0] === 'Z' & zid == -1)
                        zid = i
                    if (h[0] === 'F' & fid == -1)
                        fid = i
                })
            }
            else
                headers = headers.map((h,i) => "Col. # " + i.toString())
            if (fid === -1) fid = 0
            if (xid === -1) xid = 1
            if (yid === -1) yid = xid+1
            if (zid === -1) zid = yid+1

            // try to guess which reference dataset
            this.dataId = 0
            challengeData['name'].forEach((d,i) => {
                if (files[0]['name'].indexOf(d) > -1) {
                    this.dataId = d
                }
            })
            document.getElementById("ref_dataset").value = this.dataId

            // setState will trigger the re-rendering
            this.setState({
                FileHeader: headers,
                FileData: lines,
                FileName: files[0]['name'],
                xid: xid,
                yid: yid,
                zid: zid,
                fid: fid
            })
            // loading is done => display the full page
            document.getElementById("parameter-container").style={display:"flex"}
            document.getElementById("beads_upload").style={display:"block"}
            if (headers.length > 0)
                this.updatePlot()
        }
    }

    onChangeBeads(e){
        
        let files = e.target.files;
        let reader = new FileReader();
        let csv_sep = document.getElementById("csv_sep").value;

        reader.readAsText(files[0]);
        //once data is loaded
        reader.onload= (e)=> {
            let allText = e.target.result;
            var allTextLines = allText.split(/\r\n|\n/);
            var headers = allTextLines[0].split(csv_sep);
            
            if (headers.length === 1)
                return

            var lines = [];
        
            for (var i=1; i<Math.min(allTextLines.length,80000); i++) {
                var data = allTextLines[i].split(csv_sep);
                if (data.length === headers.length) {
                    var tarr = [];
                    for (var j=0; j<headers.length; j++) {
                        tarr.push(data[j]);
                    }
                    lines.push(tarr);
                }
            }

            this.state.FileDataBeads = lines
            this.state.FileNameBeads = files[0].name
            document.getElementById("wobbleChart").style={display:"block"}
            this.updateBeadsPlot();
        }
    }

     getMean(arr){
        let sum = 0
        arr.forEach(a => sum += a)
        return sum/arr.length
    }

    updateBeadsPlot() {
        // lets assume data is formated like the main file
        this.beadsX = [] 
        this.beadsY = []
        // check if the FileNameBeads is defined
        console.log(this.state.FileNameBeads)
        if (this.state.FileNameBeads.length > 0) {
            var i =0;
            var tx = new Array(151); var ty = new Array(151);
            var xx = new Array(151)
            for (i = 0 ; i< 151; i++){
                tx[i] = []
                ty[i] = []
                xx[i] = -750+i*10
            }

            let lines = this.state.FileDataBeads;

            for(i = 0; i < lines.length; i++){
                let index = lines[i][this.state.fid]-1;
                if (index <= 150 & index >= 0) {
                    tx[index].push(parseFloat(lines[i][this.state.xid]))
                    ty[index].push(parseFloat(lines[i][this.state.yid]))
                }
            }
            tx = tx.map(x => this.getMean(x))
            ty = ty.map(y => this.getMean(y))
            this.beadsX = tx.map(x => x-tx[75])
            this.beadsY = ty.map(y => y-ty[75])

            Chart.defaults.global.elements.line.fill = false;
            let ctx = document.getElementById("canvasWobble").getContext("2d")
            if (this.chart == null){
                this.chart = new Chart(ctx,{
                    type: 'line',
                    data: { 
                        labels: xx,
                        datasets: [{
                                label: "beadsX",
                                data: this.beadsX,
                                borderColor: "#0000ff" //blue
                            },
                            {
                                label: "beadsY",
                                data: this.beadsY,
                                borderColor: "#ffaa00" //orange
                            }
                        ]
                    },
                options:{
                    scales :{
                    xAxes: [{
                        scaleLabel: {
                        display: true,
                        labelString: "Axial position (nm)"
                            }
                        
                        }],
                    yAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: "Lateral wobble (nm)"
                            }
                        
                        }]
                    }
                    }
                })
            } else {
                // update the chart
                // this.chart.data.labels.pop();
                // this.chart.data.datasets.forEach((dataset) => {
                //     dataset.data.pop();
                //     dataset.label.pop();
                // });
                // this.chart.data.datasets.push(this.beadsX)
                // this.chart.data.datasets.push(this.beadsY)
                this.chart.data.datasets[0].data = this.beadsX;
                this.chart.data.datasets[1].data = this.beadsY;
                this.chart.update();
            }
        }
        //update page
        this.setState({update:!this.state.update})
    }

    updatePlot() {
        // grab data in nm
        let xnm = this.state.FileData.map(l => parseFloat(l[this.state.xid])/this.cFactor[0])
        let ynm = this.state.FileData.map(l => parseFloat(l[this.state.yid])/this.cFactor[1])
        let znm = this.state.FileData.map(l => parseFloat(l[this.state.zid])/this.cFactor[2])
        let nanmask = []
        xnm.forEach((x,i) => {
            if (isNaN(x) | isNaN(ynm[i]) | isNaN(znm[i]) )
                nanmask[i] = false
            else
                nanmask[i] = true
        })
        xnm = xnm.filter((x,i) => nanmask[i])
        ynm = ynm.filter((y,i) => nanmask[i])
        znm = znm.filter((z,i) => nanmask[i])
        
        // compute number of pixels XY
        let x0 = 0, y0 = 0, x1 = 6400, y1 = 6400, z0 = -750, z1 = 750 
        this.fovxnm = x1-x0
        this.fovynm = y1-y0
        this.fovznm = z1-z0
        this.sx = Math.ceil((x1-x0)/this.psXY)
        this.psXY = (x1-x0)/this.sx
        this.psXY = this.psXY.toString().substring(0,4)
        this.sy = Math.ceil((y1-y0)/this.psXY)
        this.sz = Math.ceil((z1-z0)/this.psZ)

        this.psZ = this.fovznm/this.sz

        if (this.flipY)
            ynm = ynm.map((y)=> (this.fovynm-y))

        var offset = 0;
        if (this.offset50nm)
            offset = 50;
        this.xImg = xnm.map(x => Math.floor((x-offset-x0)/(x1-x0)*(this.sx-1)))
        this.yImg = ynm.map(y => Math.floor((y-offset-y0)/(y1-y0)*(this.sy-1)))
        this.zImg = znm.map(z => {
            if (this.sz > 1)
                return Math.floor((z-this.zOffset-z0)/(z1-z0)*(this.sz-1))
            else
                return 0
        })

        this.getMaxProj()
    }

    /*flipImage() {
        if (this.flipY) 
            this.yImg = this.yImg.map((y)=> (this.sy-1)-y)
        
        if (this.flipZ) 
            this.zImg = this.zImg.map((z)=> (this.sz-1)-z)

        this.getMaxProj()
    }*/

    getMaxProj(){
        // build new Array
        var img = new Array(this.sx*this.sy*this.sz)
        for(var i = 0; i < img.length; i++)
            img[i] = 0;
        // populate array zyx order
        this.xImg.forEach((x,i) => {
            img[(this.yImg[i]*this.sx*this.sz + this.xImg[i]*this.sz + this.zImg[i])] += 1;
        })
        // compute maximum projection
        let img2d = new Array(this.sx*this.sy)
        let zindexmap = new Array(this.sx*this.sy)
        for(var i = 0; i < img2d.length; i++){
            let zprofile = img.slice(i*this.sz,(i+1)*this.sz)
            var maxval = 0; var maxind = -1;
            zprofile.forEach( (zp,j) => {
                if (zp >= maxval){
                    maxval = zp
                    maxind = j
                }
            })
            zindexmap[i] = maxind
            img2d[i] = maxval
        }
        
        // normalize brightness
        let imgMax = 0; let zindexmax= 0;
        img2d.forEach(i => {
            if (i > imgMax)
                imgMax = i
            if (zindexmap[i] > zindexmax)
                zindexmax = zindexmap[i]
        })
        if (imgMax === 0)
            imgMax = 1
        if (zindexmax === 0)
            zindexmax = 1

        img2d = img2d.map(pixel => this.A*(pixel/imgMax))
        img2d = img2d.map(pixel => {
            if (pixel > 1)
                return 1
            else
                return pixel
        })

        // grab canvas element
        var c = document.getElementById("myCanvas")
        c.width = this.sx; c.height = this.sy
        let ctx = c.getContext("2d")

        var imgData = ctx.createImageData(this.sx,this.sy)
        var i = 0
        if (this.sz > 1)
            for(i = 0; i < img2d.length; i++){
                let index = i*4;
                imgData.data[index+0] = 0*img2d[i]//*cmap[zindexmap[i]][0] //RGBA
                imgData.data[index+1] = 255*img2d[i]//*cmap[zindexmap[i]][1] 
                imgData.data[index+2] = 0*img2d[i]//*cmap[zindexmap[i]][2] 
                imgData.data[index+3] = 255;
            }
        else {
            let cLength = morgenstemning.length-1
            for (i = 0; i < img2d.length; i++){
                let index = i*4;
                imgData.data[index+0] = morgenstemning[Math.floor(cLength*img2d[i])][0] //RGBA
                imgData.data[index+1] = morgenstemning[Math.floor(cLength*img2d[i])][1] 
                imgData.data[index+2] = morgenstemning[Math.floor(cLength*img2d[i])][2] 
                imgData.data[index+3] = 255;
            }
        }
        ctx.putImageData(imgData,0,0);
        
        if(this.sz > 1) {// if data is not 2D
            // repeat for XZ projection
            // build new Array
            var img = new Array(this.sx*this.sy*this.sz)
            for(var i = 0; i < img.length; i++)
                img[i] = 0;
            // populate array zyx order
            this.xImg.forEach((x,i) => {
                img[(this.zImg[i]*this.sx*this.sy + this.xImg[i]*this.sy + this.yImg[i])] += 1;
            })
            // compute maximum projection
            let img2d = new Array(this.sx*this.sz)
            let zindexmap = new Array(this.sx*this.sz)
            for(var i = 0; i < img2d.length; i++){
                let zprofile = img.slice(i*this.sy,(i+1)*this.sy)
                var maxval = 0; var maxind = -1;
                zprofile.forEach( (zp,j) => {
                    if (zp >= maxval){
                        maxval = zp
                        maxind = j
                    }
                })
                zindexmap[i] = maxind
                img2d[i] = maxval
            }
            
            // normalize brightness
            let imgMax = 0; let zindexmax= 0;
            img2d.forEach(i => {
                if (i > imgMax)
                    imgMax = i
                if (zindexmap[i] > zindexmax)
                    zindexmax = zindexmap[i]
            })
            if (imgMax === 0)
                imgMax = 1
            if (zindexmax === 0)
                zindexmax = 1

            img2d = img2d.map(pixel => this.A*(pixel/imgMax))
            img2d = img2d.map(pixel => {
                if (pixel > 1)
                    return 1
                else
                    return pixel
            })
            // upsample for display
            let img2dUp = new Array(this.sx*5*this.sz)
            var i = 0
            for (i = 0; i < img2dUp.length; i++){
                let index = i%this.sx + this.sx*(Math.floor(i/(5*this.sx)))
                img2dUp[i] = img2d[index]
            }
            // grab canvas element
            var c = document.getElementById("canvasXZ")
            c.width = this.sx; c.height = 5*this.sz
            let ctx = c.getContext("2d")
            // apply colormap
            //let cmap = []
            //for (var i = 0; i <= this.sy; i++ )
            //    cmap.push([255*i/this.sy,255*(1-i/this.sy),255*(i/this.sy)])
            
            var imgData = ctx.createImageData(this.sx,5*this.sz)
            
            for(i = 0; i < img2dUp.length; i++){
                let index = i*4;
                imgData.data[index+0] = 0//img2d[i]*cmap[zindexmap[i]][0] //RGBA
                imgData.data[index+1] = 255*img2dUp[i]//*cmap[zindexmap[i]][1]
                imgData.data[index+2] = 0//img2d[i]*cmap[zindexmap[i]][2]
                imgData.data[index+3] = 255;
            }
            ctx.putImageData(imgData,0,0);
        }
        //update page
        this.setState({update:!this.state.update})
    }

    doDelayedUpdate(str,obj) {
        let val = parseFloat(str)
        if (!isNaN(val)){
            if( this.timeout)
                clearTimeout(this.timeout);
            
            if (obj === "cFactor")
                this.timeout = setTimeout(() => this.updatePlot(), 500);
            else if (obj === "brightness")
                this.timeout = setTimeout(() => this.getMaxProj(), 500);
            else if (obj === "zOffset")
                this.timeout = setTimeout(() => this.updatePlot(), 500);

        }
    }

    parseConversionFactor = (str) => {
        let tmp = str.split(',')
        tmp = tmp.filter((t) => t.length > 0)
        if (tmp.length === 1)
            tmp = [parseFloat(tmp[0]),parseFloat(tmp[0]),parseFloat(tmp[0])]
        else if (tmp.length === 2)
            tmp =  [parseFloat(tmp[0]),parseFloat(tmp[0]),parseFloat(tmp[1])]
        else
            tmp =  [parseFloat(tmp[0]),parseFloat(tmp[1]),parseFloat(tmp[2])]
        return tmp
    }

    uploadResults(){
        const data = new FormData()
        data.append('datasetName',this.dataId)
        data.append('xnm',this.state.FileData.map(l => parseFloat(l[this.state.xid])))
        data.append('ynm',this.state.FileData.map(l => parseFloat(l[this.state.yid])))
        data.append('znm',this.state.FileData.map(l => parseFloat(l[this.state.zid])))
        data.append('frame',this.state.FileData.map(l => parseFloat(l[this.state.fid])))
        data.append('cFactor',this.cFactor)
        data.append('offset50nm',this.offset50nm)
        data.append('zOffset',this.zOffset)
        data.append('flipY',this.flipY)
        data.append('flipZ',this.flipZ)
        data.append('beadsX',this.beadsX)
        data.append('beadsY',this.beadsY)
        data.append('frameIndex',this.frameIndex)
        const fetchPath = "/api/assessResults"
        console.log(data)
        this.setState({isLoading:true,response:0})
        fetch(fetchPath,
        {
            method: 'post',
            headers: {
                "Accept": "application/text"
            },
            mode: 'same-origin',
            body: data
        }).then (response => {
            console.log(response)
            if (response.ok) {
                response.json().then(data => {
                    // response should contain full assessment => another display container at the bottom
                    console.log(data)
                    this.setState({assessment:data,
                                   response:1,
                                   isLoading:false})
                })
            } else {
                this.setState({response:-1})
            }
        })
    }

    render() {
        return (
        <div>
            <h1>Upload your *.csv file</h1>
            <div style={{display:"flex"}}>
                <div className="upload">
                    <input type="file" name="upload-input" className="upload-input" id="upload-input" onChange={(e) => this.onChange(e)}/>
                    <label htmlFor="upload-input" className="btn btn-secondary btn-sm icon-right">
                        Choose a csv localization file
                        <svg className="icon" aria-hidden="true">
                        <use xlinkHref="#icon-upload"></use>
                        </svg>
                    </label>
                    <span className="upload-preview" style={{fontSize:"16px",marginLeft:"5px"}}>
                        {this.state.FileName.length > 0 ?
                            (<br></br>,this.state.FileName)
                            : 'No file'
                        }
                    </span>
                    <div style={{display:"flex"}}>
                        <span className="form-group">
                            <label>Select csv separator</label>
                            <select  id="csv_sep" className="custom-select">
                                <option value={","} key={0}>Comma</option>
                                <option value={";"} key={1}>Semicolon</option>
                                <option value={"\t"} key={2}>Tab</option>
                            </select>
                        </span>
                        <span className="form-group">
                            <label>Select reference dataset</label>
                            <select  id="ref_dataset" className="custom-select" onChange={() => {
                                this.dataId = document.getElementById("ref_dataset").value
                                console.log(this.dataId)
                                this.updatePlot()
                            }}>
                                {challengeData['name'].map((d,i) => {
                                    return <option value={d} key={i}>{d}</option>
                                })}
                            </select>
                        </span>
                    </div>
                </div>
                <div className="upload" id="beads_upload" style={{display:"none"}}>
                    <input type="file" name="upload-input-beads" className="upload-input" id="upload-input-beads" onChange={(e) => this.onChangeBeads(e)}/>
                    <label htmlFor="upload-input-beads" className="btn btn-secondary btn-sm icon-right">
                        Choose a beads file
                        <svg className="icon" aria-hidden="true">
                        <use xlinkHref="#icon-upload"></use>
                        </svg>
                    </label>
                    <span className="upload-preview" style={{fontSize:"16px",marginLeft:"5px"}}>
                        {this.state.FileNameBeads.length > 0 ?
                            this.state.FileNameBeads
                            : 'No file'
                        }
                    </span>
                </div>
            </div>
            {<div id="parameter-container" style={{display:"none"}}> 
                <div style={{display:"flex",margin:"10px"}}>
                  <span className="form-group">
                        <label>Select header for x location</label>
                        <select id="xid" className="custom-select" value ={this.state.xid}
                            onChange={() => {this.state.xid = document.getElementById("xid").value
                                this.updatePlot()
                                this.updateBeadsPlot()}}>
                            {this.state['FileHeader'].map((h,i) => {
                                return (<option value={i} key={i}>{h}</option>)
                            })
                            }
                        </select>
                    </span>
                    <span className="form-group">
                        <label>Select header for y location</label>
                        <select id="yid" className="custom-select" value ={this.state.yid}
                            onChange={() => {this.state.yid = document.getElementById("yid").value
                                this.updatePlot()
                                this.updateBeadsPlot()}}>
                            {this.state['FileHeader'].map((h,i) => {
                                return (<option value={i} key={i}>{h}</option>)
                            })
                            }
                        </select>
                    </span>
                    <span className="form-group">
                        <label>Select header for z location</label>
                        <select id="zid" className="custom-select" value ={this.state.zid}
                            onChange={() => {this.state.zid = document.getElementById("zid").value
                                this.updatePlot()
                                this.updateBeadsPlot()}}>
                            {this.state['FileHeader'].map((h,i) => {
                                return (<option value={i} key={i}>{h}</option>)
                            })
                            }
                        </select>
                    </span>
                    <span className="form-group">
                        <label>Select header for frames</label>
                        <select id="fid" className="custom-select" value ={this.state.fid}
                            onChange={() => {this.state.fid = document.getElementById("fid").value
                                this.updateBeadsPlot()}}>
                            {this.state['FileHeader'].map((h,i) => {
                                return (<option value={i} key={i}>{h}</option>)
                            })
                            }
                        </select>
                    </span>
                </div>
                <div style={{display:"flex",margin:"10px"}}>
                    <span className="form-group">
                        <label htmlFor="awesome-input">Conversion factor [localization units/nm]</label>
                        <input type="text" id="cFactor" className="form-control" placeholder="1,1,1" aria-describedby="awesome-input-help"
                            onChange={()=> {
                                this.cFactor = this.parseConversionFactor(document.getElementById("cFactor").value)
                                this.doDelayedUpdate(this.cFactor,"cFactor");
                            }}/>
                        <small id="awesome-input-help" className="form-text text-muted">
                            All your localizations will be divided by this number. Provide two numbers (separated by a comma) if the z scale is different. Provide three numbers if x,y and z scales are different.
                            <br></br>Default is 1 (i.e. localizations are already in nm) for all axis
                        </small>
                    </span>
                    <span className="form-group" style={{marginLeft:"10px"}}>
                        <label htmlFor="awesome-input">Starting frame index</label>
                        <input type="text" id="frameIndex" className="form-control" placeholder="1" aria-describedby="awesome-input-help"
                            onChange={()=> {
                                this.frameIndex = parseFloat(document.getElementById("frameIndex").value)
                                if (isNaN(this.frameIndex) | this.frameIndex < 0 | this.frameIndex > 1)
                                    this.frameIndex = 1
                                document.getElementById("frameIndex").value = this.frameIndex.toString();
                                this.doDelayedUpdate(this.frameIndex,"frameIndex");
                            }}/>
                        <small id="awesome-input-help" className="form-text text-muted">
                            Please indicate your indexing convention for frame number (either 1 or 0)
                            <br></br>Default is 1 
                        </small>
                    </span>
                </div>
                <h5>Data preview: uploaded data is shown in green; reference data* is shown in magenta;
                FOV: {(this.fovxnm/1000).toString().substring(0,5)} um x 
                 {(this.fovynm/1000).toString().substring(0,5)} um x 
                 {(this.fovznm/1000).toString().substring(0,5)} um (pixel size: 
                 {this.psXY} x {this.psXY} x {Math.round(this.psZ)} nm)</h5>
                 <small id="awesome-input-help" className="form-text text-muted">
                    * Reference data was obtained by rendering a random subset of the ground-truth locations with a uniform jittering of +/-30nm in xy and +/-60nm in z.
                </small>
                 <div style={{display:"flex"}}>
                    <span style={{margin:"5px"}}>
                        <label htmlFor="awesome-input" style={{marginRight:"5px"}}> Brightness: </label>
                        <input type="text" id="brightness" placeholder={this.A} aria-describedby="awesome-input-help" onChange={() => {
                            this.A = parseFloat(document.getElementById("brightness").value)
                            this.doDelayedUpdate(document.getElementById("brightness").value,"brightness")
                        }}
                            style={{width:"100px"}}/>
                    </span>
                    <span className="custom-control custom-checkbox" style={{margin:"5px"}}>
                            <input type="checkbox" className="custom-control-input" id="offset50nm" onClick={()=> {
                                this.offset50nm = !this.offset50nm;this.updatePlot()}}/>
                            <label className="custom-control-label" htmlFor="offset50nm">50nm offset?</label>
                    </span>                <div style={{display:"flex"}}>
                    <span className="custom-control custom-checkbox" style={{margin:"5px"}}>
                        <input type="checkbox" className="custom-control-input" id="custom-check1" onClick={()=> {
                            this.flipY = !this.flipY
                            //this.yImg = this.yImg.map((y)=> (this.sy-1)-y)
                            this.updatePlot()
                            }}/>
                        <label className="custom-control-label" htmlFor="custom-check1">Flip y axis?</label>
                    </span>
                    {/* <span className="custom-control custom-checkbox" style={{margin:"5px"}}>
                        <input type="checkbox" className="custom-control-input" id="custom-check2" onClick={()=> {
                            this.flipZ = !this.flipZ
                            this.zImg = this.zImg.map((z)=> (this.sz-1)-z)
                            this.getMaxProj()
                            }}/>
                        <label className="custom-control-label" htmlFor="custom-check2">Flip z axis?</label>
                    </span> */}
                    <span style={{margin:"5px"}}>
                        <label htmlFor="awesome-input" style={{marginRight:"5px"}}> Z offset (nm): </label>
                        <input type="text" id="zOffset" placeholder={this.zOffset} aria-describedby="awesome-input-help" onChange={() => {
                            this.zOffset = parseFloat(document.getElementById("zOffset").value)
                            this.doDelayedUpdate(document.getElementById("zOffset").value,"zOffset")
                        }}
                            style={{width:"100px"}}/>
                    </span>
                </div>

                </div> 
                <div style={{display:"flex"}}>
                    <div>
                        <div style={{position:"relative",margin:"10px",backgroundColor:"black",width:"650px"}}>
                            <div style={{position:"absolute",top:"0px",left:"0px"}}>
                                <canvas id="myCanvas" width="0" height="0">
                                </canvas>
                            </div>
                            <div style={{position:"relative",top:"0px",left:"0px",opacity:"0.5"}}>
                                <img src={this.refIm_XY[this.dataId]}/>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div style={{position:"relative",margin:"10px",backgroundColor:"black",width:"650px"}}>
                            <div style={{position:"absolute",top:"0px",left:"0px"}}>
                                <canvas id="canvasXZ" width="0" height="0" >
                                </canvas>
                            </div>
                            <div style={{position:"relative",top:"0px",left:"0px",opacity:"0.5"}}>
                                <img src={this.refIm_XZ[this.dataId]}/>
                            </div>
                        </div>
                        <div id="wobbleChart" style={{textAlign:"center",display:"none",margin:"10px"}} >
                            <h4 style={{textAlign:"center"}}>Wobble data</h4>
                            <canvas id="canvasWobble" height="400" width="650">
                            </canvas>
                        </div>
                    </div>
                </div>
                <div>
                    <div style={{display:"flex", justifyContent:"center",margin:"10px"}}>
                        <button className="btn btn-primary" onClick={()=> this.uploadResults()}> Run automatic assessment (20-40 sec.)</button>
                    </div>
                </div>
                {(this.state.response === 0 && this.state.isLoading === true) && // waiting for response
                    <EpflLoader/>
                }
                {this.state.response === 1 && 
                    <div>
                        <br></br>
                        <div className="alert alert-success alert-dismissible fade show" role="alert">
                            <strong>Automatic assessment</strong>  has been performed successfully.
                            <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        {JSON.stringify(this.state.assessment,null,2).split("\n").map((i,key) => {
                            return <div key={key}>{i}</div>;
                        })}
                    </div>
                }
                {this.state.response === -1 && 
                    <div>
                        <br></br>
                        <div className="alert alert-danger alert-dismissible fade show" role="alert">
                            <strong>Error !</strong> Something went wrong with the automatic assessment. Please try again.
                            <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                }
            </div>}
        </div>
      );
    }
}

export default SubmitResults;